import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutTopBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayoutTopBottom"><Path d="M20.5 6.5V17.5L3.5 17.5V6.5L20.5 6.5Z" stroke="currentColor"/><Path d="M21 20.5H3" stroke="currentColor"/><Path d="M21 3.5H3" stroke="currentColor"/></CentralIconBase>;
});

export default IconLayoutTopBottom;
